import request from '@/utils/request'

// 列表
export function listPage(data) {
  return request({
    url: 'admin/data/mapepalert/list',
    method: 'post',
    data
  })
}

export function secureAssociationGroup(data) {
  return request({
    url: 'admin/data/mapepalert/secureAssociationGroup',
    method: 'post',
    data
  })
}
export function associationList(data) {
  return request({
    url: 'admin/data/mapepalert/associationList',
    method: 'post',
    data
  })
}
export function associationGroup(data) {
  return request({
    url: 'admin/data/mapepalert/associationGroup',
    method: 'post',
    data
  })
}
export function alertDisposeNew(data) {
  return request({
    url: 'admin/data/mapepalert/alertDisposeNew',
    method: 'post',
    data
  })
}

// 下一个书签
export function nextBookmark(data) {
  return request({
    url: 'admin/data/mapepalert/nextBookmark',
    method: 'post',
    data
  })
}

// 上一个书签
export function previousBookmark(data) {
  return request({
    url: 'admin/data/mapepalert/previousBookmark',
    method: 'post',
    data
  })
}

// 告警处理
export function alertDispose(data) {
  return request({
    url: 'admin/data/mapepalert/alertDispose',
    method: 'post',
    data
  })
}

// 忽略告警提醒
export function alertIgnore(data) {
  return request({
    url: 'admin/data/mapepalert/alertIgnore',
    method: 'post',
    data
  })
}

// 添加书签
export function addBookmark(data) {
  return request({
    url: 'admin/data/mapepalert/addBookmark',
    method: 'post',
    data
  })
}

// 删除书签
export function delBookmark(data) {
  return request({
    url: 'admin/data/mapepalert/delBookmark',
    method: 'post',
    data
  })
}

// 下拉信息初始化
export function initSelect() {
  return request({
    url: 'admin/data/mapepalert/init',
    method: 'get'
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/data/mapepalert/info/' + id,
    method: 'get'
  })
}

// 详情(无需权限)
export function infoByWorker(id) {
  return request({
    url: 'admin/data/mapepalert/infoByWorker/' + id,
    method: 'get'
  })
}

//统计台账
export function statisticalledger(data) {
  return request({
    url: 'admin/data/mapepalert/statisticalledger',
    method: 'post',
    data
  })
}
// 列表
export function listPageWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/list',
    method: 'post',
    data
  })
}
export function auditWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/audit',
    method: 'post',
    data
  })
}
// 详情
export function infoWater(id) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/info/' + id,
    method: 'get'
  })
}


// 忽略告警提醒
export function alertIgnoreWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/alertIgnore',
    method: 'post',
    data
  })
}
export function alertDisposeNewWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/alertDisposeNew',
    method: 'post',
    data
  })
}
export function secureAssociationGroupWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/secureAssociationGroup',
    method: 'post',
    data
  })
}
export function associationListWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/associationList',
    method: 'post',
    data
  })
}
export function associationGroupWater(data) {
  return request({
    url: 'admin/data/vbusSpsDatWaterhourinfectan/associationGroup',
    method: 'post',
    data
  })
}
